import React, { ReactText, ReactNode } from 'react'
import Box from 'shared/components/Box'
import styled from 'styled-components'
import CustomTooltip from 'shared/components/CustomTooltip'

type ParticipantInfoProps = {
  id?: string
  label: string | ReactNode
  value: any
  hasTooltip?: boolean
  tooltipMessage?: string
}

const ParticipantInfo: React.FC<ParticipantInfoProps> = props => {
  const { id, label, value, hasTooltip = false, tooltipMessage = '' } = props

  return (
    <ParticipantInfoContainer id={id && id}>
      <InfoLabel id={id && `${id}__label`}>
        {label}
        {hasTooltip && <CustomTooltip className="custom-tt" placement="bottom" title={tooltipMessage} />}
      </InfoLabel>
      <InfoValue id={id && `${id}__value`}>{value !== '' ? value : '-'}</InfoValue>
    </ParticipantInfoContainer>
  )
}

const ParticipantInfoContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 16px;
`

const InfoLabel = styled(Box)`
  font-weight: bold;
  line-height: 19px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  .custom-tt {
    margin: 0;
  }
`

const InfoValue = styled(Box)`
  line-height: 22px;
`

export default ParticipantInfo
